// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
    gap: 8px;
    padding: 10px;
  }

  .image-item {
    width: 100%;
    height: auto;
    aspect-ratio: 1 / 1;
    object-fit: cover;
    border-radius: 8px;
    cursor: pointer;
    transition: transform 0.2s ease-in-out;
  }

  .image-item:hover {
    transform: scale(1.05);
  }

  .selected {
    border: 3px solid #28a745; /* Green border for selected images */
  }

  .image-placeholder {
    width: 100%;
    aspect-ratio: 1 / 1;
    background-color: #f8f9fa;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    border-radius: 8px;
  }

  .image-item-container {
    position: relative;
    display: inline-block;
  }
  
  .image-tooltip {
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    z-index: 9000;
    background: white;
    border: 1px solid #ccc;
    padding: 5px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }
  
  .image-tooltip-img {
    max-width: 500px;
    max-height: 500px;
    display: block;
  }`, "",{"version":3,"sources":["webpack://./src/components/EmojisCard/emojis-card.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,2DAA2D;IAC3D,QAAQ;IACR,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,yBAAyB,EAAE,qCAAqC;EAClE;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,aAAa;IACb,iBAAiB;IACjB,sBAAsB;IACtB,YAAY;IACZ,uCAAuC;EACzC;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;EAChB","sourcesContent":[".image-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));\n    gap: 8px;\n    padding: 10px;\n  }\n\n  .image-item {\n    width: 100%;\n    height: auto;\n    aspect-ratio: 1 / 1;\n    object-fit: cover;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: transform 0.2s ease-in-out;\n  }\n\n  .image-item:hover {\n    transform: scale(1.05);\n  }\n\n  .selected {\n    border: 3px solid #28a745; /* Green border for selected images */\n  }\n\n  .image-placeholder {\n    width: 100%;\n    aspect-ratio: 1 / 1;\n    background-color: #f8f9fa;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    border-radius: 8px;\n  }\n\n  .image-item-container {\n    position: relative;\n    display: inline-block;\n  }\n  \n  .image-tooltip {\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    transform: translateX(-50%);\n    z-index: 9000;\n    background: white;\n    border: 1px solid #ccc;\n    padding: 5px;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  }\n  \n  .image-tooltip-img {\n    max-width: 500px;\n    max-height: 500px;\n    display: block;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
